import axios from "axios";

function getResultInit(objData) {
  return new Promise((resolve, reject) => {
    let port = "";
    if (process.env.ROOT_API.includes("viewmedonline")) port = ":3000";
    axios
      .get(
        process.env.ROOT_API +
          "/laboratories/institutions/patiens/" +
          objData.idInstitution,
        {
          headers: {
            Authorization: objData.token,
          },
          params: {
            skip: objData.skip,
            limit: objData.count,
            filter: objData.filter,
            dateFrom: objData.dateFrom,
            dateTo: objData.dateTo,
          },
        }
      )
      .then((result) => {
        resolve(result.data.documents);
      })
      .catch((error) => {
        reject(error.response);
      });
  });
}

function getPatientInfo(objData) {
  return new Promise((resolve, reject) => {
    let port = "";
    if (process.env.ROOT_API.includes("viewmedonline")) port = ":3001";
    axios
      .get(process.env.ROOT_API + "/laboratories/query/" + objData.section, {
        headers: {
          Authorization: objData.token,
        },
        params: {
          idUser: objData.idUser,
          institution_id: objData.idInstitution,
        },
      })
      .then((result) => {
        resolve(result.data.documents);
      })
      .catch((error) => {
        reject(error.response.data.message);
      });
  });
}

function getResultItem(objData) {
  return new Promise((resolve, reject) => {
    try {
      let port = "";
      if (process.env.ROOT_API.includes("viewmedonline")) port = ":3003";
      axios
        .get(process.env.ROOT_API + "/item_lab/" + objData.id, {
          headers: {
            Authorization: objData.token,
          },
        })
        .then((result) => {
          resolve(result.data.documents);
        })
        .catch((error) => {
          reject(error.response);
        });
    } catch (err) {
      console.log("Error in getResultItem, CRUD Laboratory: ", err);
    }
  });
}

function showGraphic(objData) {
  return new Promise((resolve, reject) => {
    let port = "";
    if (process.env.ROOT_API.includes("viewmedonline")) port = ":3004";
    axios
      .get(
        process.env.ROOT_API +
          "/laboratories/graphic/" +
          objData.section +
          "/" +
          objData.position,
        {
          headers: {
            Authorization: objData.token,
          },
          params: {
            idUser: objData.id,
            idInstitution: objData.idInstitution,
          },
        }
      )
      .then((result) => {
        resolve(result.data.documents);
      })
      .catch((error) => {
        reject(error.response);
      });
  });
}

function getFile(objData) {
  return new Promise((resolve, reject) => {
    try {
      let port = "";
      if (process.env.ROOT_API.includes("viewmedonline")) port = ":3027";
      axios
        .get(process.env.ROOT_API + "/get_file/" + objData.fileId, {
          headers: {
            Authorization: objData.token,
          },
          responseType: "blob", //blob
        })
        .then((result) => {
          resolve(result.data);
        })
        .catch((error) => {
          reject(error.response);
        });
    } catch (err) {
      console.log("Err in getFile: ", err);
    }
  });
}

function getPatientExist(objData) {
  return new Promise((resolve, reject) => {
    try {
      let port = "";
      if (process.env.ROOT_API.includes("viewmedonline")) port = ":3032";
      axios
        .get(process.env.ROOT_API + "/persons/exists/" + objData.emailUser, {
          headers: {
            Authorization: objData.token,
          },
        })
        .then((result) => {
          resolve(result.data.documents[0]._id);
        })
        .catch((error) => {
          reject(error.response);
        });
    } catch (err) {
      console.log("Error in getResultItem, CRUD Laboratory: ", err);
    }
  });
}

const notificationMail = async (data) => {
  let response = null;
  try {
    response = await fetch(`https://services.viewmedonline.com/mail/sg/v2`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    });
    return response.json();
  } catch (error) {
    console.log(error);
  }
  return response;
};

const notificationPhone = async (data) => {
  let response = null;
  try {
    response = await fetch(
      `https://services.viewmedonline.com/notification/phone`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      }
    );
    return response.json();
  } catch (error) {
    console.log(error);
  }
  return response;
};

const getpdfLab = async (params) => {
  try {
    let response = await fetch(
      `https://services.viewmedonline.com/laboratory/file/${params.id}/${params.id_lab}?hours=${params.hours}`,
      {
        method: "get",
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    return response.json();
  } catch (error) {
    console.log("Error getpdfLab: ", error);
    return null;
  }
};

const getSearchLaboratories = async (params) => {
  try {
    const urlParams = new URLSearchParams(params).toString();
    let response = await fetch(
      `https://services.viewmedonline.com/laboratory/search?${urlParams}`,
      {
        method: "get",
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    const docs = await response.json();
    return docs.docs[0];
  } catch (error) {
    console.log("Error getpdfLab: ", error);
    return null;
  }
};

const getSectionsListByUser = async (email, shared, institutionId) => {
  try {
    const urlParams = shared
      ? `?findShared=true`
      : `?institutionId=${institutionId}`;
    let response = await fetch(
      `https://services.viewmedonline.com/laboratory/sections/list/${email}${urlParams}`,
      {
        method: "get",
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    const docs = await response.json();
    return docs.docs;
  } catch (error) {
    console.log("Error getpdfLab: ", error);
    return null;
  }
};

export {
  getResultInit,
  getPatientInfo,
  getResultItem,
  showGraphic,
  getFile,
  getPatientExist,
  notificationMail,
  notificationPhone,
  getpdfLab,
  getSearchLaboratories,
  getSectionsListByUser,
};



// WEBPACK FOOTER //
// ./src/components/laboratory/laboratorySer.js